import React from 'react';

const ProfilesIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M23 5H10.67l-.44-1.32a1 1 0 0 0-1-.68H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-1 14H2V7h20z"/></svg>    )
};

export default ProfilesIcon;